import jQuery from 'jquery';
import { RaceDayLive } from 'rp-race-day-live';

export default class RaceDayLiveCards {
    constructor(raceDayLiveConfig) {
        const defaultConfig = {
            componentId: 'rdl-content'
        };

        this.dropDownSelector = '.js-RC-RaceDayLive';
        this.config = jQuery.extend(true, defaultConfig, raceDayLiveConfig);
        this.$component = document.getElementById(this.config.componentId);
        if (this.$component) {
            const courseId = parseInt(this.$component.getAttribute('data-courseid'), 10);
            const RDL = new RaceDayLive();

            RDL.init({ currentFilter: courseId });
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/raceDayLive.js